export default __webpack_public_path__ + "static/media/ficha_projeto_FSE_RHAQ_AI_FV_page-0001.df477fe2.jpg";